import {TUICallEngine, TUICallEvent, TUICallType} from "tuicall-engine-webrtc";
import TencentCloudChat, {ChatSDK} from "@tencentcloud/chat";
import {BEMessageType} from "../Chat/type";
import {sleep} from "../Chat/connector";

export const initTencentCall = async (params: {
    appId: number, userId: string, userSig: string
}) => {
    const callEngine = TUICallEngine.createInstance({
        SDKAppID: params.appId || 20021923,
    });

    //Login
    await callEngine.login({
        userID: params.userId,
        userSig: params.userSig,
    }).then(() => {
        console.log("Login successful");
    }).catch((error) => {
        console.error("Login failed:", error);
    });

    return callEngine;
};

export const startCall = async (callEngine: any, params: {
    callType: TUICallType,
    userIDList: Array<string>,
    groupID?: string,
    roomID?: string,
    userData?: any
}) => {
    try {
        const result = await callEngine.groupCall({
            type: params?.callType,
            groupID: params?.groupID,
            userIDList: params?.userIDList || [],
            userData: JSON.stringify(params?.userData || {}),
            timeout: 60, // seconds,
            roomID: params?.roomID ? (parseInt(params.roomID) || undefined) : undefined,
        });
        console.log('Call started successfully:', result);
        return result;
    } catch (error) {
        console.error("Start call failed:", error);
        return null;
    }
};

export const joinCall = async (callEngine: any, params: {
    roomID: string,
    type: TUICallType,
    groupID?: string,
}) => {
    try {
        await callEngine.joinInGroupCall({
            roomID: params.roomID,
            type: TUICallType.VIDEO_CALL,
            groupID: params.groupID || "",
        });
        return true;
    } catch (error) {
        console.error("Join call failed:", error);
        return false;
    }
};

export const sentCallStateMessage = async (chat: ChatSDK, toId: string, message: BEMessageType | any, state: "CALL-STATE" | "CALL-LEAVE-STATE" | "CALL-END-STATE" | "CALL-JOIN-STATE") => {
    try {
        const beMessage = {
            tencentUserId: message.tencentUserId,
            bookingId: message.bookingId,
            eventName: state,
            tencentGroupId: message.tencentGroupId,
            threadId: message.threadId,
            name: message.name,
            isCalling: message.isCalling,
            roomID: message.roomID,
            callInfo: message.callInfo || null,
        };
        const tencentMessage = chat.createTextMessage({
            to: toId,
            conversationType: TencentCloudChat.TYPES.CONV_GROUP,
            payload: {
                text: JSON.stringify(beMessage),
            },
            needReadReceipt: true
        });
        const result = await chat.sendMessage(tencentMessage, {
            messageControlInfo: {
                excludedFromUnreadCount: true,
                excludedFromLastMessage: true
            }
        }).catch(reason => null);
    } catch (e) {
        return null;
    }
}
